/* eslint-disable */

(function() {
  "use strict";

  $(".telIcon").click(function() {
    $(this)
      .siblings(".numberArea")
      .toggleClass("opennumber");
    $(".tel").toggleClass("active");
  });

  $(".signupIcon").click(function() {
    $(this)
      .siblings(".signArea")
      .toggleClass("opennumber");
    $(".signup").toggleClass("active");
  });
})();
